module.exports = __webpack_public_path__ + "img/banner-dog-desk.d6e361a7.jpg";